import React from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { CornerStyle } from '@atlassian/company-hub-common';
import { CornerStyleConfig } from '@atlassian/company-hub-common/config-panel';

import { carouselNewParametersV2 } from '../../../../controllers/use-carousel-extension-parameters-and-actions';
import { type UpdateMainFormFieldType } from '../../../../controllers/use-carousel-extension-parameters-and-actions/types';
import type { CarouselParameters } from '../../../../types';
import { AutoplayToggle } from '../../fields/autoplay-toggle';

type CarouselConfigStylesSectionGeneralProps = {
	cornerStyle: CarouselParameters['cornerStyle'];
	isAutoplayEnabled: CarouselParameters['isAutoplayEnabled'];
	isCompanyHub: boolean;
	source: string;
	updateMainFormField: UpdateMainFormFieldType;
};

export const CarouselConfigStylesSectionGeneral = ({
	isCompanyHub,
	isAutoplayEnabled,
	updateMainFormField,
	cornerStyle,
	source,
}: CarouselConfigStylesSectionGeneralProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleCornerStyleChange = (newCornerStyle: CornerStyle) => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'cornerStyling',
				source,
				attributes: {
					cornerStyle: newCornerStyle,
				},
			},
		}).fire();

		updateMainFormField({ cornerStyle: newCornerStyle });
	};

	return (
		<>
			<AutoplayToggle
				isAutoplayEnabled={isAutoplayEnabled}
				updateMainFormField={updateMainFormField}
			/>
			{isCompanyHub && (
				<CornerStyleConfig<CornerStyle>
					cornerStyleValue={cornerStyle || carouselNewParametersV2.cornerStyle}
					updateCornerStyle={handleCornerStyleChange}
					roundCornerValue={CornerStyle.ROUNDED}
					squareCornerValue={CornerStyle.SQUARED}
				/>
			)}
		</>
	);
};
